import React, { useState } from 'react';
import styled from 'styled-components/macro';
import ListItemIcon from '@mui/material/ListItemIcon';
import { StyledMenu, StyledMenuItem } from './styled';
import SubMenu from './SubMenu';

const Wrapper = styled.div`
    z-index: 2000;
`;

const FramiIconMenu = ({ options, children, onClose, topComponent, setHoverLocked }) => {
    const [anchorEl, setAnchorEl] = useState();
    const open = !!anchorEl;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        if (setHoverLocked) {
            setHoverLocked(true);
        }
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
        setAnchorEl(null);
        if (setHoverLocked) {
            setTimeout(() => {
                setHoverLocked(false);
            }, 300);
        }
    };

    return (
        <Wrapper>
            {children(handleClick)}
            <StyledMenu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {topComponent && topComponent(handleClose)}
                {options.map((o, idx) => {
                    if (o.subMenu) {
                        return (
                            <SubMenu key={idx} title={o.text} icon={o.icon} options={o.subMenu} onClose={handleClose} />
                        );
                    } else {
                        return (
                            <StyledMenuItem
                                data-cy={`menu-item-${o.name}`}
                                selected={o.selected}
                                disabled={o.disabled}
                                className={`menuItem${o.name}`}
                                key={idx}
                                onClick={() => {
                                    handleClose();
                                    o.onClick();
                                }}
                            >
                                <ListItemIcon>{o.icon}</ListItemIcon>
                                {o.text}
                            </StyledMenuItem>
                        );
                    }
                })}
            </StyledMenu>
        </Wrapper>
    );
};

export default FramiIconMenu;
